import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
    selector: '[dateInput]',
    standalone: false
})
export class DateInputDirective implements OnInit {

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    let dateVal = this.el.nativeElement.value;
    if (dateVal.length === 2 || dateVal.length === 5) {
      if (event.code != 'Backspace') {
        this.el.nativeElement.value = dateVal + '/';
      }
    }
  }

}
